import React, { useMemo } from "react"
import {
  formatAmount,
  formatTenure,
  getIcdRequestStatus,
  getIcdsStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"
import { Link } from "react-router-dom"
import moment from "moment"
import eye from "../../../assets/images/icons/eye.svg"
import TableContainer from "components/Common/TableContainer"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

function IcdByInvestor({ data, close }) {
  const columns = useMemo(
    () => [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Request ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-number">{row?.original.unique_code}</div>
        ),
      },

      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Amount (₹)"),
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <div>₹ {formatAmount(row?.original.amount)}</div>,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, " Interest"),
        accessorKey: "interest_rate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">{row?.original.interest_rate} %</div>
        ),
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, " Tenure"),
        accessorKey: "tenure",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">{formatTenure(row?.original.tenure)}</div>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Fund Availability Date"),
        accessorKey: "fund_requirement_date",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>
            {moment(row?.original.fund_requirement_date).format("D MMM YYYY")}
          </>
        ),
      },
      {
        header: () => <div className="flex items-center gap-2">Status</div>,
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const original = row?.original
          const icdsReq = original?.icdsRequest
          const showIcdRequestStatus =
            ["OPEN", "CLOSED", "CANCELLED", "REJECTED"].includes(
              original?.status
            ) || !icdsReq?.approved_at

          return (
            <div className="code-status">
              {showIcdRequestStatus
                ? icdsReq
                  ? getIcdRequestStatus(icdsReq.status)
                  : getIcdsStatus(original?.status)
                : getIcdsStatus(original?.status)}
            </div>
          )
        },
      },
      {
        id: "action",
        header: "",
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="action-view">
              <Link
                to={`/icd-investments/my-icds/view/${row?.original.id}`}
                onClick={close}
              >
                <img src={eye} alt="" />
              </Link>
            </div>

            {/* <div
              className="action-delete"
              onClick={() => {
                deleteRef.current = row?.original
                setIsToast(true)
              }}
            >
              <img src={deleteIcon} alt="" />
            </div> */}
          </div>
        ),
      },
    ],
    []
  )

  return (
    <>
      {/* <Breadcrumb title={"Icd investments by Me"} /> */}
      <TableContainer
        // isLoading={isFetching}
        // count={count}
        title={"Icd investments by Me"}
        filters={defaultFilters}
        // setFilters={setFilters}
        columns={columns}
        data={data}
        isCustomPageSize={false}
        isPagination={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}

export default IcdByInvestor
